import Container from "layouts/container/Container";
import { useEffect } from "react";
import { useLocation } from 'react-router-dom';

function Payment(props) {
    const location = useLocation();

    useEffect(() => {
        // URL에서 쿼리 문자열 추출
        const queryParams = new URLSearchParams(location.search);
        const dataParam = queryParams.get('data');

        // dataParam을 사용하여 원하는 처리 수행
        if (dataParam) { 
            // dataParam을 사용하여 puffu://MainScreen으로 이동
            const newUrl = `puffu://action`;
            // const newUrl = `puffu://MainScreen?data=${dataParam}`;
            window.location.href = newUrl;
            setTimeout(() => {
                window.location.href = "https://play.google.com/apps/test/com.worldintl.puffu/12";
                // window.location.href = "https://play.google.com/store/apps/details?id=com.worldintl.puffu&hl=en-US&ah=P69ZjaDp0PXvi-PKhpzdBG3oQwY";
            }, 1000); // 1초 후에 실행
        }
    }, []);

    return (
        <Container>
            앱 있으면 앱켜고 없으면 설치
        </Container>
    );
}

export default Payment;